import { render, staticRenderFns } from "./BookingAndRooms.vue?vue&type=template&id=1a598f00&scoped=true&"
import script from "./BookingAndRooms.vue?vue&type=script&lang=js&"
export * from "./BookingAndRooms.vue?vue&type=script&lang=js&"
import style0 from "./BookingAndRooms.vue?vue&type=style&index=0&id=1a598f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a598f00",
  null
  
)

export default component.exports